import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BaseURL } from "../../App";
import { useQuery } from "@tanstack/react-query";
import Skeleton from "../ui/Skeleton";

const Udemy = () => {
  const [courses, setCourses] = useState([]);

  const [nextPage, setNextPage] = useState(null);
  const [previousPage, setPreviousPage] = useState(null);

  const [search, setSearch] = useState("tabla");

  const fetchCourses = async () => {
    try {
      const response = await fetch(`${BaseURL}/api/courses`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ search }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch courses");
      }

      const data = await response.json();
      return data;

      // console.log(data);
      // console.log(data.results);
      // console.log(data.next);

      // setCourses(data.results);
      // setNextPage(data.next);
      // setPreviousPage(data.previous);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };
  const {
    data: productdata,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["courses"],
    queryFn: fetchCourses,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (productdata) {
      setCourses(productdata.results || []);
      setNextPage(productdata.next);
      setPreviousPage(productdata.previous);
    }
  }, [productdata]);

  const handlePageChange = async (pageUrl) => {
    try {
      const response = await fetch(`${BaseURL}/api/pageChange`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ pageUrl }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch page of courses");
      }

      const data = await response.json();

      setCourses(data.results);
      setNextPage(data.next);
      setPreviousPage(data.previous);
    } catch (error) {
      console.error("Error fetching page of courses:", error);
    }
  };

  const handleNextPage = () => {
    if (nextPage) {
      handlePageChange(nextPage);
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top
    }
  };

  const handlePreviousPage = () => {
    if (previousPage) {
      handlePageChange(previousPage);
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top
    }
  };

  return (
    <div className="p-2 bg-white animate-fadeIn">
      <div className="my-3 ml-5">
        <Link to="/">Home</Link> / Courses
        <h1 className="text-center text-4xl pb-2 font-bold">Courses</h1>
        <div className="text-center">
          <p className="text-lg text-gray-600 mb-4">
            Explore our selection of online courses for learning music.
          </p>
          <div className="flex justify-center items-center">
            <input
              className="border border-black px-4 py-2 rounded-md mr-2 focus:outline-none"
              placeholder="Enter the name of the instrument.."
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button
              onClick={refetch}
              className="bg-blue-950 hover:bg-blue-900 text-white font-semibold py-2 px-4 rounded focus:outline-none"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Skeleton />
      ) : (
        courses?.map((course) => (
          <div
            className="group mx-2 mt-5 grid max-w-screen-lg grid-cols-1 space-x-8 overflow-hidden rounded-lg border text-gray-700 shadow transition hover:shadow-lg sm:mx-auto sm:grid-cols-5"
            key={course.id}
          >
            <a
              href="#"
              className="col-span-2 text-left text-gray-600 hover:text-gray-700"
            >
              <div className="group relative h-full w-full overflow-hidden">
                <img
                  src={course.image_480x270}
                  alt=""
                  className="h-full w-full border-none object-cover text-gray-700 transition group-hover:scale-125"
                />
                <span className="absolute top-2 left-2 rounded-full bg-yellow-200 px-2 text-xs font-semibold text-yellow-600"></span>
                <img
                  src="/images/AnbWyIjnwNbW9Wz6c_cja.svg"
                  className="absolute inset-1/2 w-10 max-w-full -translate-x-1/2 -translate-y-1/2 transition group-hover:scale-125"
                  alt=""
                />
              </div>
            </a>
            <div className="col-span-3 flex flex-col space-y-3 pr-8 text-left">
              <a
                href="#"
                className="mt-3 overflow-hidden text-2xl font-semibold"
              >
                {course.title}
              </a>
              <p className="overflow-hidden text-sm">{course.headline}</p>
              <a
                href="#"
                className="text-sm font-semibold text-gray-500 hover:text-gray-700"
              >
                {course.visible_instructors[0]?.display_name}
              </a>
              <div className="mt-5 flex items-center">
                <div className="flex items-center">
                  <svg
                    className="block h-4 w-4 align-middle text-yellow-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    ...
                  </svg>
                  {/* Repeat the star icons for rating */}
                  {/* {course.price} */}
                </div>
                <p className="ml-2 text-sm font-medium text-gray-500">
                  {/* {course.price} Reviews */}
                </p>
              </div>

              <div className=" flex flex-col text-gray-700 sm:flex-row justify-between items-end">
                <div className="my-5 rounded-md px-5 py-2 text-center transition hover:scale-105 bg-green-100 text-green-700">
                  {course.price}
                </div>
                <a
                  href={`https://www.udemy.com${course.url}`}
                  target="_blank"
                  rel="noreferrer"
                  className="my-5 rounded-md px-5 py-2 text-center transition hover:scale-105 bg-orange-600 text-white"
                >
                  Enroll Now
                </a>
              </div>
            </div>
          </div>
        ))
      )}

      <div className="flex justify-around mt-4 px-2">
        <button
          onClick={handlePreviousPage}
          disabled={!previousPage}
          className={`${
            previousPage ? "bg-gray-500" : "bg-gray-200"
          } text-white font-semibold py-2 px-4 rounded`}
        >
          Previous Page
        </button>
        <button
          onClick={handleNextPage}
          disabled={!nextPage}
          className={`${
            nextPage ? "bg-gray-500" : "bg-gray-200"
          } text-white font-semibold py-2 px-4 rounded`}
        >
          Next Page
        </button>
      </div>
    </div>
  );
};

export default Udemy;

// https://www.udemy.com/api-2.0/courses/?search=tabla&category=Music&subcategory=Instruments
